import React from "react";

const useBoolean = (initialValue?: boolean) => {
  const [value, setValue] = React.useState(Boolean(initialValue));
  const setTrue = () => {
    setValue(true);
  };
  const setFalse = () => {
    setValue(false);
  };
  const toggle = () => {
    setValue((pre) => !pre);
  };

  return [value, { set: setValue, setTrue, setFalse, toggle }] as const;
};

export default useBoolean;
